import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  useRecoilCallback,
  useRecoilValue,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useSetRecoilState,
} from "recoil";
import AutocompleteSkeleton from "src/shared/components/skeletons/AutocompleteSkeleton";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";

import AutocompleteTipoExamen from "./components/autocompletes/AutocompleteTipoExamen";
import AutocompleteExamen from "./components/autocompletes/AutocompleteExamen";
import {
  tipoExamenState,
  tipoExamenesFetchState,
  examenState,
  examenesFetchState,
  ExamenByTipoExamenState,
  sucursalesImagenologiaFetchState,
  sucursalesState,
  sucursalesFetchState,
  sucursalesImagenologiaState,
} from "./components/autocompletes/state/atoms";
import {
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "./state/atoms";
import AutocompleteSucursalesImagenologia from "./components/autocompletes/AutocompleteSucursalesImagenologia";
import TipoExamenService from "src/services/agenda/tipoExamen";
import { InputRut } from "src/shared/components/forms/InputRut";
import { userState } from "src/store/user/userState";

const FormSearchImagenologia = ({
  size = "small",
  md = 12,
  styles = {},
  buttonSearch = null,
}) => {
  const { catchErrorApi } = useCatchErrorApi();
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const setSucursales = useSetRecoilState(sucursalesImagenologiaState);
  const setTipoExamen = useSetRecoilState(tipoExamenState);
  const setExamen = useSetRecoilState(examenState);
  const [loading, setLoading] = useState(false);
  const user = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(userState);

  const loadData = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        try {
          const sucursalesFetch = snapshot.getPromise(
            sucursalesImagenologiaFetchState
          );
          const sue_correl = filterSearchSelected.sucursalSelected.sue_correl;

          const tipoExamenesFetch = await TipoExamenService.getAll(sue_correl);

          const responses = await Promise.all([sucursalesFetch]);

          setSucursales(responses[0]);
          setTipoExamen(tipoExamenesFetch.data.data);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    []
  );

  useEffect(() => {
    loadData();

    return () => {
      loadData();
    };
  }, [loadData]);

  useEffect(() => {
    return () => {
      setIsChangeFormSearch(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //const myFunction = async (obj) => {
  const myFunction = useRecoilCallback(
    ({ snapshot }) =>
      async (obj) => {
        const examenesFetch = snapshot.getPromise(
          ExamenByTipoExamenState(obj.ptD_RUT)
        );
        const responses = await Promise.all([examenesFetch]);
        setExamen(responses[0]);
      },
    []
  );

  return (
    <Grid container spacing={3}>
      {!user.isAuthenticated && (
        <Grid item md={md} xs={12} bottom>
          <InputRut form="imagenologia" styles={{ ...styles }} />
        </Grid>
      )}
      <Grid item md={md} xs={12}>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteSucursalesImagenologia
            size={size}
            styles={{ ...styles }}
          />
        )}
      </Grid>

      <Grid item md={md} xs={12} bottom>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteTipoExamen
            size={size}
            styles={{ ...styles }}
            myEvent={myFunction}
          />
        )}
      </Grid>

      <Grid item md={md} xs={12}>
        {loading ? (
          <AutocompleteSkeleton />
        ) : (
          <AutocompleteExamen size={size} styles={{ ...styles }} />
        )}
      </Grid>

      {buttonSearch && (
        <Grid
          display={"flex"}
          justifyContent="center"
          alignItems={"center"}
          item
          md={md}
          xs={12}
        >
          {buttonSearch}
        </Grid>
      )}
    </Grid>
  );
};

export default FormSearchImagenologia;
